// i18next/no-literal-string enforcement note:
// eslint-plugin-i18next@6.1.4 is installed as a dev dependency.
// The project currently uses oxlint as its sole linter (vp lint = oxlint via vite-plus).
// oxlint does not support ESLint plugins, so the i18next/no-literal-string rule cannot be
// wired into the lint pipeline in this phase. All worker-app t() call sites have been
// manually audited (Tasks 28-53) and every key is present in translations.json.
// TODO: enable the rule once ESLint is added alongside oxlint, or when oxlint ships
//       native i18next support.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import nl from "./translations.json";

void i18n.use(initReactI18next).init({
  resources: { nl: { translation: nl } },
  lng: "nl",
  fallbackLng: false,
  returnNull: false,
  interpolation: { escapeValue: false },
});

function syncHtmlLang(lng: string) {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
}
syncHtmlLang(i18n.language);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
